import * as React from 'react';
import Field from "./Field";
import List from "./List";
import useForm from "./useForm";
import FieldForm from "./Form";
import { FormProvider } from "./FormContext";
import FieldContext from "./FieldContext";
import ListContext from "./ListContext";
import useWatch from "./useWatch";
const InternalForm = /*#__PURE__*/React.forwardRef(FieldForm);
const RefForm = InternalForm;
RefForm.FormProvider = FormProvider;
RefForm.Field = Field;
RefForm.List = List;
RefForm.useForm = useForm;
RefForm.useWatch = useWatch;
export { Field, List, useForm, FormProvider, FieldContext, ListContext, useWatch };
export default RefForm;